export default function CtaPanel() {
  return (
    <section id="cta" className="mx-auto max-w-page px-4 pb-4 pt-4 md:px-6">
      <div className="relative overflow-hidden rounded-lg border border-accent-200/70 bg-accent-100/50 px-6 py-10 text-center md:px-10 md:py-14">
        <i className="ri-goblet-line absolute -left-4 bottom-2 text-7xl text-accent-200/60"></i>
        <i className="ri-eye-line absolute -right-3 top-3 text-7xl text-accent-200/60"></i>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent-700">
          面向读者的深挖协作
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
          你手里的那张截图，也许就是最后一块拼图
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-foreground-600">
          我们坚持只做公开交叉验证：真实身份、背后金主、隐藏关系与私下聊天的每一处结论，
          都留档、可复核、可纠错。欢迎你加入这场关于未公开信息的共读。
        </p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#comments"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-message-3-line"></i>
            去评论区补刀
          </a>
          <a
            href="#top"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-500"
          >
            从头看本期深挖
          </a>
        </div>
      </div>
    </section>
  );
}